import { API
       , kde_api_user_t }         from '../02_api'
import { CRUD
       , FACTORY
       }                          from '../09_model_app'


let g_users: MUsers ;

export class MUsers
{
  users = new CRUD<kde_api_user_t>(
      (user) => API.USERS( user? user.workgroup!.cloud.id : 0
                         , user? user.workgroup!.id : 0 )
    , ( user ) => 
      FACTORY.WORKGROUP_USERS.data_fetcher_for( { cloud_id: user? user.workgroup!.cloud.id : 0
                                              , workgroup_id: user? user.workgroup!.id : 0 } )
    ) ;


  static instance ( )
  {
    if ( !g_users )
        g_users = new MUsers( ) ;

    return g_users ;
  }
}